import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {AddinBridgeService} from "../../cad-model-upload/data-access/addin-bridge.service";
 
/**
 * When the web app is opened from inside the SolidWorks addin  which is WebView2, land
 * on the CAD Data page instead of the dashboard.
 */
export const addinLandingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const addinBridge = inject(AddinBridgeService);
  return (addinBridge.isInAddin && !router.navigated)
    ? router.parseUrl('/cad-data') : true;
};
 